import {
  Dmenu
} from './dmenu.js'; //ドロワーメニュー
import {
  Env
} from './env.js'; //ブラウザなど環境チェック
//import { youtubeLazy } from './youtube-lazyload.js';//Youtube遅延(スクロール到達時)読み込み
import {
  ScrChecker
} from './scroll-checker-simple.js';
//import { Acc } from './accordion.js';//アコーディオン
import {
  Swp
} from './swp.js'; //Swiper
import {
  SwpProd
} from './swp-product.js'; //Swiper
import {
  PageAncher
} from './pageancher.js'; //ページ内アンカーリンク（スムーズスクロール）
import {
  LogoutRedirect
} from './logout-redirect.js'; //サイズを整数に
//リサイズ
import {
  ResizeElem
} from './resize.js';
import {
  ModalContactProd
} from './modal-contact-prod.js';


import smoothscroll from 'smoothscroll-polyfill';
// window.scroll smooth not working on Safari
// https://stackoverflow.com/questions/51731754/window-scroll-smooth-not-working-on-safari
// Window.scroll() https://developer.mozilla.org/en-US/docs/Web/API/Window/scroll

export class Main {
  constructor() {
    this.timerResized = false; //resize時
    this.timerScrolled = false; //scroll時
    this._click = '';
    this.env = {};
    //this.youtubeLazy = {};
    this.loadedFlg = false;
    this.scrChecker = {};
    //this.pageAncher = {};
    //this.accordions = {};
    this.sliders = {};
    this.prodSliders = {};
    //this.openingManager = {};
    this.tabs = {};
    //this.sizeint= {};
    this.resize = {};
    this.modalcontactprod = {};
  }


  fixMobileSafariResponsiveImages() {
    // モバイルSafariでコンテンツをAjaxでloadした場合、pictureのartdirectionが効かない件
    // よくiPadで問題になる
    // https://stackoverflow.com/questions/45487105/ajax-loaded-images-in-safari-not-respecting-srcset
    if (document.querySelectorAll('picture')[0]) {
      let target = document.querySelectorAll('picture');
      for (let i = 0; i < target.length; i++) {
        target[i].outerHTML = target[i].outerHTML;
      }
    }
  }

  init() {
    //console.log('init');
    //this.scrCheck = new ScrPos();
    this.body = document.getElementsByTagName('body')[0];
    this.html = document.getElementsByTagName('html')[0];

    // DOMContentLoaded時
    // ------------------------------
    window.addEventListener('DOMContentLoaded', () => {

      // ブラウザOS環境
      this.env = new Env();
      this.env.detectEnv();

      // スクロールチェッカー
      this.scrChecker = new ScrChecker();
      this.scrChecker.init();



      // Resize
      this.resize = new ResizeElem();


      // スクロール時
      window.addEventListener('scroll', () => {
        //console.log(this.env.browser.ie11);

        // ie11もヘッダー関係で
        //if (this.env.browser.ie11 !== true) {
        this.scrChecker.onUpdate();
        //}

      });

      // ウインドウリサイズ時
      window.addEventListener('resize', () => {
        this.scrChecker.onUpdate();
        //var _this = this;
        if (this.timerResized !== false) {
          clearTimeout(this.timerResized);
        }
        this.timerResized = setTimeout(() => {
          //this.accordions.accResize();
          this.resize.resizing();
        }, 700);
      });

      // dmenu
      let dmenu = new Dmenu();
      dmenu.init();


      //resize
      //this.resize.resizing();


      // contact form (MW WP FORM)
      let errorNoticeTargets = document.querySelectorAll('.js-contact-intro');
      let errorNoticeClass = 'has-error';
      if (document.querySelectorAll('.mw_wp_form .error')[0]) { //エラーの有無
        errorNoticeClass = 'has-error';
      } else {
        errorNoticeClass = 'no-error';
      }
      for (let i = 0; i < errorNoticeTargets.length; i++) {
        errorNoticeTargets[i].classList.add(errorNoticeClass);
      }


    });

    // load時
    // ------------------------------
    window.addEventListener("load", () => {
      this.loadedFlg = true;
      window.setTimeout(() => {
        this.body.classList.add('loaded');
        //this.body.classList.add('opening-skipped'); //OP設置前のみ
      }, 100);

      //youtube lazyload
      // this.youtubeLazy = new youtubeLazy();
      // this.youtubeLazy.init();
      // this.youtubeLazy.onScroll();

      //URLパラメータ
      //this.paramAncher = new Pla();
      //this.paramAncher.getParam('pa', location.href);

      //ログアウトリンク クリック時リダイレクト
      //this.logoutRedirect = new LogoutRedirect();
      //this.logoutRedirect.init();


      //page ancher
      smoothscroll.polyfill();
      this.pageAncher = new PageAncher();
      this.pageAncher.init();

      var _this = this;
      window.setTimeout(function () {
        _this.scrChecker.onUpdate();

        // lazy load (image in swiper)
        //const observer = lozad(); //'.lozad'
        //observer.observe();

        // lazy load (image in swiper)
        if (document.querySelectorAll('.lozad')[0]) {
          let lzTarget = document.querySelectorAll('.lozad');
          for (let i = 0; i < lzTarget.length; i++) {
            let srcLazy = lzTarget[i].dataset.src;
            lzTarget[i].setAttribute('src', srcLazy);
            lzTarget[i].classList.add('src-lazy-replaced');
          }
        }

      }, 500);


      // Swiper/Ajax/Template
      this.sliders = new Swp();
      this.prodSliders = new SwpProd();
      let template;
      let clone;
      if (document.getElementById('index-content-template')) {
        template = document.getElementById('index-content-template');
        clone = template.content.cloneNode(true);
        document.getElementById('js-index-content-container').appendChild(clone);

        window.setTimeout(() => {
          this.fixMobileSafariResponsiveImages(); // safari対策
          this.sliders.init();
          this.prodSliders.init(); // Swiper(IE11などはload時に初期化)
        }, 100);
      } else {
        this.sliders.init();
        this.prodSliders.init();
      }

      // 商品ページお問合せ
      this.modalcontactprod = new ModalContactProd();
      this.modalcontactprod.init();


      //整数サイズへ
      //this.sizeint.sizeInt();

      // リサイズ
      this.resize.resizing();

    });
  }
}